import { forwardRef } from 'react';

import { Input, message } from 'antd';
import type { InputProps, InputRef } from 'antd';

type PasteOnlyInputProps = InputProps;

const PasteOnlyInput = forwardRef<InputRef, PasteOnlyInputProps>(({ value, onChange, ...rest }, ref) => {
  const [messageApi, contextHolder] = message.useMessage({ maxCount: 1 });

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!e.ctrlKey && !e.metaKey) {
      e.preventDefault();
      messageApi.open({ type: 'warning', content: 'Ввод не поддерживается, только вставка' });
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedText = e.clipboardData.getData('Text');

    const syntheticEvent = {
      target: { value: pastedText },
    } as unknown as React.ChangeEvent<HTMLInputElement>;

    onChange?.(syntheticEvent);

    messageApi.open({ type: 'info', content: 'Вставка выполнена' });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === '') {
      onChange?.(e);
    } else {
      e.preventDefault();
    }
  };

  return (
    <>
      {contextHolder}
      <Input
        ref={ref}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
        allowClear
        {...rest}
      />
    </>
  );
});

PasteOnlyInput.displayName = 'PasteOnlyInput';

export default PasteOnlyInput;
